import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-contrato-fechado',
  templateUrl: './contrato-fechado.component.html',
  styleUrls: ['./contrato-fechado.component.scss'],
})
export class ContratoFechadoComponent { }
